import PixQrCode from "./PixQrCode";

export default PixQrCode;
